type Tick = (dt: number, now: number) => void;
const ticks = new Set<Tick>();
let raf = 0;
let last = 0;
let inFrame = false;

function frame(now: number) {
  inFrame = true; // kick() is a no-op mid-frame; we reschedule exactly once below
  const dt = Math.min(0.05, last ? (now - last) / 1000 : 1 / 60);
  last = now;
  ticks.forEach((t) => {
    try { t(dt, now); } catch (err) { if (process.env.NODE_ENV !== 'production') console.error('[mania/play]', err); }
  });
  inFrame = false;
  raf = ticks.size && !document.hidden ? requestAnimationFrame(frame) : 0;
  if (!raf) last = 0;
}

function kick() { if (!raf && !inFrame && ticks.size && !document.hidden) raf = requestAnimationFrame(frame); }

if (typeof document !== 'undefined') document.addEventListener('visibilitychange', kick);

export const playLoop = {
  register(tick: Tick): () => void {
    ticks.add(tick); kick();
    return () => { ticks.delete(tick); };
  },
  kick,
};
